import { always } from 'ramda'

const SoftwareCatalogPermissions = {
  read: always(true),
}

export default SoftwareCatalogPermissions
